import { OfferTypeEnum, Dictionary } from '../Models';

export class OfferTypeHelper {
    // Transform an OfferTypeEnum to a Dictionary of type [offertTypeEnum] => label
    static GetDictionaryValues(
        offerType: OfferTypeEnum,
        employmentLabel: string,
        studentLabel: string
    ): Dictionary<number, string>[] {
        const offerTypeDictionary: Dictionary<number, string>[] = [];

        if (
            (offerType & OfferTypeEnum.Actiris) !== 0 ||
            (offerType & OfferTypeEnum.Internal) !== 0 ||
            (offerType & OfferTypeEnum.External) !== 0 ||
            (offerType & OfferTypeEnum.Traineeship) !== 0
        ) {
            offerTypeDictionary.push({
                value:
                    (offerType & OfferTypeEnum.Actiris) |
                    (offerType & OfferTypeEnum.Internal) |
                    (offerType & OfferTypeEnum.External) |
                    (offerType & OfferTypeEnum.Traineeship),
                label: employmentLabel,
            });
        }

        if ((offerType & OfferTypeEnum.Student) !== 0) {
            offerTypeDictionary.push({
                value: OfferTypeEnum.Student,
                label: studentLabel,
            });
        }

        return offerTypeDictionary;
    }
}
